module.exports = "https://static.energy5.com/_next/static/images/thermostatBg-1b3c5055e3639689ef703313b2618328.webp";